import { CtrlType } from "@yuigoto/ctrl";

export const BeautyProfileControl = [
  [
    {
      name: "name",
      alias: "firstName"
      , label: "Nome"
      , placeholder: "Primeiro Nome"
      , required: true
      , value: ""
      , requiredMessage: "Este campo é obrigatório"
      , minLength: 3
      , minLengthMessage: "Tamanho mínimo de 3 caracteres"
      , regex: /^([^\d]*)$/
      , regexMessage: "Valor Inválido",
      wrapClass: "col-12 col-md-6"
    },
    {
      name: "lastName"
      , label: "Sobrenome"
      , placeholder: "Último Nome"
      , required: true
      , value: ""
      , minLength: 3
      , regex: /^([^\d]*)$/
      , regexMessage: "Valor Inválido",
      wrapClass: "col-12 col-md-6"
    }
  ],
  [
    {
      name: "cpf"
      , label: "CPF"
      , type: CtrlType.CPF
      , placeholder: "xxx.xxx.xxx.-xx"
      , value: ""
      , required: true
      , cpfMessage: "Este campo é obrigatório"
      , wrapClass: "col-12 col-md-6"
    },
    {
      name: "birthday"
      , label: "Data de nascimento"
      , placeholder: "DD/MM/AAAA",
      type: CtrlType.DATE,
      wrapClass: "col-12 col-md-6"
    }],
  {
    name: "phone"
    , label: "DDD + Telefone/Celular"
    , placeholder: "(xx) x xxxx-xxxx"
    , value: ""
    , type: CtrlType.PHONE
    , minLength: 10
    , maxLength: 20
    , regex: /([\d]+)/
    , regexMessage: "Valor Inválido"
  },
  {
    name: "newsletterOptIn"
    , alias: "newsletter"
    , label: "Newsletter"
    , type: CtrlType.BOOLEAN
    , description: "Aceito receber comunicações da Glambox por e-mail ou outros meios."
    , custom: true
  }
];    